import React from "react";
import { ModalFee } from "./Fee";
import { ModalNotification } from "./Notification";
import { ModalConfirmCancel } from "./ConfirmCancel";
import { ModalCheckin } from "./Checkin";

function Modals() {
  const modals = [
    {
      id: "fees",
      component: ModalFee,
    },
    {
      id: "notification",
      component: ModalNotification,
    },
    {
      id: "confirmCancel",
      component: ModalConfirmCancel,
    },
    {
      id: "checkin",
      component: ModalCheckin,
    },
  ];

  return (
    <>
      {modals.map((m) => (
        <m.component key={m.id} />
      ))}
    </>
  );
}

Modals.Fee = ModalFee;
Modals.Notification = ModalNotification;
Modals.ConfirmCancel = ModalConfirmCancel;
Modals.Checkin = ModalCheckin;

export { Modals };
